<section id="inicioSesion" class="inicio-sesion">
  <app-header-public variant="v2" [showAuthButtons]="false" [showRegisterButton]="false"></app-header-public>

  <main class="inicio-sesion__main">
    <div class="inicio-sesion__container">
      <header class="inicio-sesion__heading">
        <h1 class="inicio-sesion__title">Inicio de sesión</h1>
        <p class="inicio-sesion__subtitle">
          Selecciona el tipo de usuario con el que deseas ingresar
        </p>
      </header>

      <div class="inicio-sesion__grid">
        @for (opcion of opciones; track opcion.id) {
        <a [id]="'btn-login-' + opcion.id" [routerLink]="opcion.ruta" class="inicio-sesion__option"
          [attr.aria-label]="opcion.etiquetaAccesible">
          <img [src]="opcion.imagen" alt="" class="inicio-sesion__option-img" />
        </a>
        }
      </div>
    </div>
  </main>

  <app-home-site-footer></app-home-site-footer>
</section>